import IonToolbar from '../../../../../components/Modal/ModalToolbar';
import { IonBackButton, IonButtons, IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonPage, IonTitle, IonToast, useIonViewDidEnter } from '@ionic/react';
import { arrowBack, bookOutline, cardOutline, listOutline, navigateOutline, printOutline, removeCircleOutline, settingsOutline, shareSocialOutline, storefrontOutline, syncOutline, ticketOutline, timeOutline } from 'ionicons/icons';
import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { MessageContext } from '../../../../../contexts/MessageContext';
import './MenuConfiguracoes.css';

type Props = {
    abrirMenu: boolean;
}

const MenuConfiguracoes: React.FC<Props> = (props: Props) => {

    const history = useHistory();
    const [showToast, setShowToast] = useState(false);
    const [textToast, setTextToast] = useState("");
    const [showToast2, setShowToast2] = useState(false);

    const [acessos] = useState<any>(JSON.parse(window.localStorage.getItem("acessos") || '{}'));
    const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
    const { nomeMenu, setNomeMenu } = useContext(MessageContext);

    useIonViewDidEnter(() => {
        setEsconderMenu(true);
        setNomeMenu("");
    });

    return (
        <IonPage className="menu-layout-page">
            <IonHeader className="ion-no-border">
                <IonToolbar className="menu-layout-toolbar">
                    <IonButtons slot="start">
                        <IonBackButton icon={arrowBack} text=''></IonBackButton>
                    </IonButtons>

                    <IonTitle slot="start">Configurações</IonTitle>
                </IonToolbar>
            </IonHeader>

            <IonContent className="menu-layout-content">

                <div className="menu-layout-container">
                    <div className="menu-layout-heading">
                        <h1>Configurações</h1>
                        <p>Personalize sua empresa, suas vendas e o funcionamento da operação.</p>
                    </div>
                    <nav className="menu-layout-grid menu-configuracoes-grid" aria-label="Configurações">

                        <h2 className="menu-layout-group" >Empresa</h2>

                        <IonItem className="menu-layout-item" hidden={acessos?.configuracoes != 'leitura' && acessos?.configuracoes != 'edicao'} lines="none" button routerLink="/empresa/contaalt" routerDirection="forward" detail >
                            <IonIcon className="menu-layout-icon" aria-hidden="true" slot="start" icon={storefrontOutline} />
                            <IonLabel><h3>Perfil</h3><p>Dados e identidade da sua empresa</p></IonLabel>
                        </IonItem>
                        {(window.localStorage.getItem("servicoPrincipal") == "Pedidos" || window.localStorage.getItem("servicoPrincipal") == "Vendas") && (
                            <IonItem className="menu-layout-item" hidden={acessos?.configuracoes != 'leitura' && acessos?.configuracoes != 'edicao'} lines="none" button routerLink="/empresa/horarios" routerDirection="forward" detail >
                                <IonIcon className="menu-layout-icon" aria-hidden="true" slot="start" icon={timeOutline} />
                                <IonLabel><h3>Horários</h3><p>Dias e horários de atendimento</p></IonLabel>
                            </IonItem>
                        )}
                        {(window.localStorage.getItem("servicoPrincipal") == "Pedidos" || window.localStorage.getItem("servicoPrincipal") == "Vendas") && (
                            <IonItem className="menu-layout-item" hidden={acessos?.configuracoes != 'leitura' && acessos?.configuracoes != 'edicao'} lines="none" button routerLink="/empresa/formapagamento" routerDirection="forward" detail >
                                <IonIcon className="menu-layout-icon" aria-hidden="true" slot="start" icon={cardOutline} />
                                <IonLabel><h3>Forma de Pagamento</h3><p>Meios de pagamento aceitos</p></IonLabel>
                            </IonItem>
                        )}
                        {(window.localStorage.getItem("servicoPrincipal") == "Pedidos" || window.localStorage.getItem("servicoPrincipal") == "Vendas") && (
                            <IonItem className="menu-layout-item" hidden={acessos?.configuracoes != 'leitura' && acessos?.configuracoes != 'edicao'} lines="none" button routerLink="/empresa/configuracoesentrega" routerDirection="forward" detail >
                                <IonIcon className="menu-layout-icon" aria-hidden="true" slot="start" icon={navigateOutline} />
                                <IonLabel><h3>Configurações de Entrega</h3><p>Áreas, taxas e opções de entrega</p></IonLabel>
                            </IonItem>
                        )}

                        {(window.localStorage.getItem("servicoPrincipal") == "Pedidos" || window.localStorage.getItem("servicoPrincipal") == "Vendas") && (
                            <h2 className="menu-layout-group" hidden={acessos?.configuracoes != 'leitura' && acessos?.configuracoes != 'edicao'}>Venda mais</h2>
                        )}

                        {(window.localStorage.getItem("servicoPrincipal") == "Pedidos" || window.localStorage.getItem("servicoPrincipal") == "Vendas") && (
                            <IonItem className="menu-layout-item" hidden={acessos?.configuracoes != 'leitura' && acessos?.configuracoes != 'edicao'} lines="none" button routerLink="/empresa/cashback" routerDirection="forward" detail >
                                <IonIcon className="menu-layout-icon" aria-hidden="true" slot="start" icon={syncOutline} />
                                <IonLabel><h3>Cashback</h3><p>Recompensas para seus clientes</p></IonLabel>
                            </IonItem>
                        )}
                        {(window.localStorage.getItem("servicoPrincipal") == "Pedidos" || window.localStorage.getItem("servicoPrincipal") == "Vendas") && (
                            <IonItem className="menu-layout-item" hidden={acessos?.configuracoes != 'leitura' && acessos?.configuracoes != 'edicao'} lines="none" button routerLink="/empresa/configuracoescupom" routerDirection="forward" detail >
                                <IonIcon className="menu-layout-icon" aria-hidden="true" slot="start" icon={ticketOutline} />
                                <IonLabel><h3>Cupom</h3><p>Descontos e cupons promocionais</p></IonLabel>
                            </IonItem>
                        )}

                        {(window.localStorage.getItem("servicoPrincipal") == "Pedidos" || window.localStorage.getItem("servicoPrincipal") == "Vendas") && (
                            <h2 className="menu-layout-group" hidden={acessos?.configuracoes != 'leitura' && acessos?.configuracoes != 'edicao'}>Novidades</h2>
                        )}

                        {(window.localStorage.getItem("servicoPrincipal") == "Pedidos" || window.localStorage.getItem("servicoPrincipal") == "Vendas") && (
                            <IonItem className="menu-layout-item" hidden={acessos?.configuracoes != 'leitura' && acessos?.configuracoes != 'edicao'} lines="none" button routerLink="/empresa/integracoes" routerDirection="forward" detail >
                                <IonIcon className="menu-layout-icon" aria-hidden="true" slot="start" icon={shareSocialOutline} />
                                <IonLabel><h3>Integrações</h3><p>Conecte os serviços da sua empresa</p></IonLabel>
                            </IonItem>
                        )}

                        {(acessos?.projetos == 'leitura' || acessos?.projetos == 'edicao') &&
                            <>

                                {(window.localStorage.getItem("servicoPrincipal") == "Pedidos" || window.localStorage.getItem("servicoPrincipal") == "Vendas") && (
                                    <h2 className="menu-layout-group" hidden={acessos?.configuracoes != 'leitura' && acessos?.configuracoes != 'edicao'}>Produtos</h2>
                                )}
                                {(window.localStorage.getItem("servicoPrincipal") == "Pedidos" || window.localStorage.getItem("servicoPrincipal") == "Vendas") && (
                                    <IonItem className="menu-layout-item" hidden={acessos?.configuracoes != 'leitura' && acessos?.configuracoes != 'edicao'} lines="none" button routerLink="/empresa/produtoscatalogo" routerDirection="forward" detail >
                                        <IonIcon className="menu-layout-icon" aria-hidden="true" slot="start" icon={bookOutline} />
                                        <IonLabel><h3>Catálogo</h3><p>Organize os itens do seu catálogo</p></IonLabel>
                                    </IonItem>
                                )}
                                {(window.localStorage.getItem("servicoPrincipal") == "Pedidos" || window.localStorage.getItem("servicoPrincipal") == "Vendas") && (
                                    <IonItem className="menu-layout-item" hidden={acessos?.configuracoes != 'leitura' && acessos?.configuracoes != 'edicao'} lines="none" button routerLink="/empresa/produtoscategoriasnovo" routerDirection="forward" detail >
                                        <IonIcon className="menu-layout-icon" aria-hidden="true" slot="start" icon={listOutline} />
                                        <IonLabel><h3>Categorias</h3><p>Agrupe e organize seu catálogo</p></IonLabel>
                                    </IonItem>
                                )}

                                {!(window.localStorage.getItem("servicoPrincipal") == "Pedidos" || window.localStorage.getItem("servicoPrincipal") == "Vendas") && (
                                    <h2 className="menu-layout-group" hidden={acessos?.configuracoes != 'leitura' && acessos?.configuracoes != 'edicao'}>Serviços</h2>
                                )}
                                {!(window.localStorage.getItem("servicoPrincipal") == "Pedidos" || window.localStorage.getItem("servicoPrincipal") == "Vendas") && (
                                    <IonItem className="menu-layout-item" hidden={acessos?.configuracoes != 'leitura' && acessos?.configuracoes != 'edicao'} lines="none" button routerLink="/empresa/servicoscatalogo" routerDirection="forward" detail >
                                        <IonIcon className="menu-layout-icon" aria-hidden="true" slot="start" icon={bookOutline} />
                                        <IonLabel><h3>Catálogo</h3><p>Organize os itens do seu catálogo</p></IonLabel>
                                    </IonItem>
                                )}
                                {!(window.localStorage.getItem("servicoPrincipal") == "Pedidos" || window.localStorage.getItem("servicoPrincipal") == "Vendas") && (
                                    <IonItem className="menu-layout-item" hidden={acessos?.configuracoes != 'leitura' && acessos?.configuracoes != 'edicao'} lines="none" button routerLink="/empresa/servicoscategorias" routerDirection="forward" detail >
                                        <IonIcon className="menu-layout-icon" aria-hidden="true" slot="start" icon={listOutline} />
                                        <IonLabel><h3>Categorias</h3><p>Agrupe e organize seu catálogo</p></IonLabel>
                                    </IonItem>
                                )}

                            </>
                        }

                        {(window.localStorage.getItem("servicoPrincipal") == "Pedidos" || window.localStorage.getItem("servicoPrincipal") == "Vendas") && (
                            <>
                                <h2 className="menu-layout-group" hidden={acessos?.configuracoes != 'leitura' && acessos?.configuracoes != 'edicao'}>Fiscal</h2>

                                <IonItem className="menu-layout-item" hidden={acessos?.configuracoes != 'leitura' && acessos?.configuracoes != 'edicao'} lines="none" button routerLink="/empresa/fiscalconfiguracoes" routerDirection="forward" detail>
                                    <IonIcon className="menu-layout-icon" aria-hidden="true" slot="start" icon={settingsOutline} />
                                    <IonLabel><h3>Configurações</h3><p>Dados e emissão de documentos fiscais</p></IonLabel>
                                </IonItem>

                                <IonItem className="menu-layout-item" hidden={acessos?.configuracoes != 'leitura' && acessos?.configuracoes != 'edicao'} lines="none" button routerLink="/empresa/fiscalcategorias" routerDirection="forward" detail>
                                    <IonIcon className="menu-layout-icon" aria-hidden="true" slot="start" icon={listOutline} />
                                    <IonLabel><h3>Categorias Fiscais</h3><p>Classificação fiscal dos produtos</p></IonLabel>
                                </IonItem>

                                <IonItem className="menu-layout-item" hidden={acessos?.configuracoes != 'leitura' && acessos?.configuracoes != 'edicao'} lines="none" button routerLink="/empresa/fiscalinutilizacao" routerDirection="forward" detail>
                                    <IonIcon className="menu-layout-icon" aria-hidden="true" slot="start" icon={removeCircleOutline} />
                                    <IonLabel><h3>Inutilização de Numeração</h3><p>Numerações de documentos não utilizadas</p></IonLabel>
                                </IonItem>
                            </>
                        )}

                        {(window.localStorage.getItem("servicoPrincipal") == "Pedidos" || window.localStorage.getItem("servicoPrincipal") == "Vendas") && (
                            <h2 className="menu-layout-group" hidden={acessos?.configuracoes != 'leitura' && acessos?.configuracoes != 'edicao'}>Configurações</h2>
                        )}
                        {(window.localStorage.getItem("servicoPrincipal") == "Pedidos" || window.localStorage.getItem("servicoPrincipal") == "Vendas") && (
                            <IonItem className="menu-layout-item" lines="none" button routerLink="/empresa/impressao" routerDirection="forward" detail >
                                <IonIcon className="menu-layout-icon" aria-hidden="true" slot="start" icon={printOutline} />
                                <IonLabel><h3>Impressão</h3><p>Impressoras e layout dos comprovantes</p></IonLabel>
                            </IonItem>
                        )}

                    </nav>
                </div>

                <IonToast
                    isOpen={showToast}
                    position="middle" //top, bottom, middle
                    onDidDismiss={() => setShowToast(false)}
                    message={textToast}
                    duration={3000}
                />
            </IonContent>

        </IonPage>
    );
};

export default MenuConfiguracoes;
